import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";

// Marounites Scouts Pages
import OurTeam from "src/pages/ourTeam/view";
import Slideshow from "src/pages/slideshow/view";
import Statistics from "src/pages/statistics/view";
import Sponsors from "src/pages/sponsors/view";
import ExecutiveCommittee from "src/pages/executive_committee/view";
import GeneralCommission from "src/pages/general_commission/view";
import ContactLocations from "src/pages/contact_locations/view";
import LocateUs from "src/pages/locate_us/view";
import Memorials from "src/pages/memorials/view";
import Sections from "src/pages/sections/view";
import HomeSections from "src/pages/home_sections/view";
import Media from "src/pages/media/view";
import Galleries from "src/pages/galleries/view";
import GalleryItems from "src/pages/gallery_items/view";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

/* ****Pages***** */
const AdminLogs = Loadable(lazy(() => import("src/pages/admins_logs/view")));
const Settings = Loadable(lazy(() => import("src/pages/settings/view")));
const EcommerceDash = Loadable(
  lazy(() => import("../views/dashboard/Home"))
);
const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view"))
);
const MediaPosts = Loadable(lazy(() => import("src/pages/media_posts/view")));
const Formations = Loadable(lazy(() => import("src/pages/formations/view")));

/* Removed all unnecessary app pages, widgets, forms, tables, charts, and UI components */

// authentication
const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login"))
);

const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("src/views/authentication/auth/ResetPassword"))
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);

const getDefaultRouteBasedOnPrivileges = () => {
  const data = getLocalStorage(dataLocalStorage.privileges);

  if (data["17"]?.access_read == 1) {
    return "/dashboard";
  } else if (data["1"]?.access_read == 1) {
    return RouterName.admins.admins;
  } else if (data["2"]?.access_read == 1) {
    return RouterName.admins_logs.admins_logs;
  } else if (data["3"]?.access_read == 1) {
    return RouterName.settings.settings;
  } else if (data["4"]?.access_read == 1) {
    return RouterName.slideshow;
  } else if (data["5"]?.access_read == 1) {
    return RouterName.home_sections;
  } else if (data["6"]?.access_read == 1) {
    return RouterName.statistics;
  } else if (data["7"]?.access_read == 1) {
    return RouterName.executive_committee;
  } else if (data["18"]?.access_read == 1) {
    return RouterName.general_commission;
  } else if (data["8"]?.access_read == 1) {
    return RouterName.sections;
  } else if (data["9"]?.access_read == 1) {
    return RouterName.ourTeam;
  } else if (data["10"]?.access_read == 1) {
    return RouterName.contact_locations;
  } else if (data["19"]?.access_read == 1) {
    return RouterName.locate_us;
  } else if (data["20"]?.access_read == 1) {
    return RouterName.memorials;
  } else if (data["11"]?.access_read == 1) {
    return RouterName.media_posts;
  } else if (data["12"]?.access_read == 1) {
    return RouterName.sponsors;
  } else if (data["16"]?.access_read == 1) {
    return RouterName.formations;
  }
  
  // Default fallback
  return "/dashboard";
};

let data = getLocalStorage(dataLocalStorage.privileges);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      {
        path: "/",
        exact: true,
        element: (
          <Navigate to={getDefaultRouteBasedOnPrivileges()} />
        ),
      },

      // Admins
      data["1"]?.access_read == 1 && {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },
      data["1"]?.access_read == 1 && {
        path: RouterName.admins.privileges,
        exact: true,
        element: <PrivilegesPage />,
      },
      data["2"]?.access_read == 1 && {
        path: RouterName.admins_logs.admins_logs,
        exact: true,
        element: <AdminLogs />,
      },
      // Settings
      data["3"]?.access_read == 1 && {
        path: RouterName.settings.settings,
        exact: true,
        element: <Settings />,
      },
      // Slideshow
      data["4"]?.access_read == 1 && {
        path: RouterName.slideshow,
        exact: true,
        element: <Slideshow />,
      },
      // Home Sections
      data["5"]?.access_read == 1 && {
        path: RouterName.home_sections,
        exact: true,
        element: <HomeSections />,
      },
      // Statistics
      data["6"]?.access_read == 1 && {
        path: RouterName.statistics,
        exact: true,
        element: <Statistics />,
      },
      // Administrative Body
      data["7"]?.access_read == 1 && {
        path: RouterName.executive_committee,
        exact: true,
        element: <ExecutiveCommittee />,
      },
      // General Commission
      data["18"]?.access_read == 1 && {
        path: RouterName.general_commission,
        exact: true,
        element: <GeneralCommission />,
      },
      // Sections
      data["8"]?.access_read == 1 && {
        path: RouterName.sections,
        exact: true,
        element: <Sections />,
      },
      // Our Team
      data["9"]?.access_read == 1 && {
        path: RouterName.ourTeam,
        exact: true,
        element: <OurTeam />,
      },
      // Contact Locations
      data["10"]?.access_read == 1 && {
        path: RouterName.contact_locations,
        exact: true,
        element: <ContactLocations />,
      },
      // Locate Us
      data["19"]?.access_read == 1 && {
        path: RouterName.locate_us,
        exact: true,
        element: <LocateUs />,
      },
      // Memorials
      data["20"]?.access_read == 1 && {
        path: RouterName.memorials,
        exact: true,
        element: <Memorials />,
      },
      // Media Posts
      data["11"]?.access_read == 1 && {
        path: RouterName.media_posts,
        exact: true,
        element: <MediaPosts />,
      },
      // Sponsors
      data["12"]?.access_read == 1 && {
        path: RouterName.sponsors,
        exact: true,
        element: <Sponsors />,
      },
      // Formations
      data["16"]?.access_read == 1 && {
        path: RouterName.formations,
        exact: true,
        element: <Formations />,
      },
      // Dashboard
      data["17"]?.access_read == 1 && {
        path: "/dashboard",
        exact: true,
        element: <EcommerceDash />,
      },
      // Media (for galleries accessed through related entities)
      {
        path: RouterName.media,
        exact: true,
        element: <Media />,
      },
      // Galleries (accessed through related entities)
      {
        path: RouterName.galleries,
        exact: true,
        element: <Galleries />,
      },
      // Gallery Items
      {
        path: RouterName.gallery_items,
        exact: true,
        element: <GalleryItems />,
      },
      { path: "/404", element: <Error /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.forgotPassword, element: <ForgotPassword /> },
      { path: RouterName.auth.resetPassword, element: <ResetPassword /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
